import { ButtonProps } from '@mui/material'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { useDownloadTemplateContractPdf } from '@src/data/api/credit-api/files-api'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'

interface Props extends ButtonProps {
  creditApp: CreditApplication
}

const SignManuallyButton = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [downloadPdf, isDownloading, isError, isSuccess] = useDownloadTemplateContractPdf(
    creditApp.financingProgramId,
    creditApp.id,
  )

  return (
    <AsyncActionButton
      fullWidth
      variant="contained"
      isPending={isDownloading}
      isError={isError}
      isSuccess={isSuccess}
      onClick={() => downloadPdf(creditApp.contract.cvtNumber)}
    >
      {t('worksheet.signManually')}
    </AsyncActionButton>
  )
}

export default SignManuallyButton
